import { render, staticRenderFns } from "./coach_message.vue?vue&type=template&id=c869a320&scoped=true"
import script from "./coach_message.vue?vue&type=script&lang=js"
export * from "./coach_message.vue?vue&type=script&lang=js"
import style0 from "./coach_message.vue?vue&type=style&index=0&id=c869a320&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c869a320",
  null
  
)

export default component.exports